import { withStyles } from '@mui/styles';
import { Button } from '@mui/material';
import { Theme } from '@mui/material/styles';

const OpaqueButton = withStyles((theme: Theme) => ({
    root: {
        '&$disabled': {
            backgroundColor: theme.palette.grey[300]
        },
        zIndex: 90
    },
    disabled: {}
}))(Button);

export default OpaqueButton;
